const moment = window.moment;
const Cookies = window.Cookies;
const $ = window.$;

customElements.define('sale-bar', class SaleBar extends HTMLElement {
    constructor() {
        super();

        if (window.discountFlag) return;
        if (window.location.pathname.includes('/cart') && Cookies.get('discount_code')) return;

        this.parent = this.parentElement;
        this.settings = JSON.parse(this.parent.querySelector('#sale-bar-vars').innerHTML);
        this.startDateCET = `${this.settings.startYear}-${this.settings.startMonth}-${this.settings.startDay}T${this.settings.startHours}:${this.settings.startMinutes}:00.000+02:00`;
        this.endDateCET = `${this.settings.endYear}-${this.settings.endMonth}-${this.settings.endDay}T${this.settings.endHours}:${this.settings.endMinutes}:59.000+02:00`;
        this.startDateTimestamp = moment(this.startDateCET).valueOf();
        this.endDateTimestamp = moment(this.endDateCET).valueOf();
        this.closeButton = this.querySelector('.close');
        this.initialize();

        this.parent.addEventListener('click', (event) => {
            this.onBarClick(event);
        });

        document.addEventListener('click', (event) => {
            this.onOutsidePopupClick(event);
        });

        this.closeButton.addEventListener('click', () => {
            this.parent.remove();
        })
    }

    initialize() {
        if (this.settings.ignoreTime) {
            this.showBar();
        } else {
            this.startCounting();
        }
    }

    showBar() {
        this.parent.setAttribute('style', 'display: block');
        this.setSupportButtonMargin(this.offsetHeight + 5);
    }

    removeBar() {
        this.remove();
        this.parent.setAttribute('style', 'unset !important');
    }

    startCounting() {
        this.counter = setInterval(this.countDown.bind(this), 1000);
    }

    onBarClick(event) {
        const link = this.settings.link;
        const image = this.settings.imgTag;
        const code = this.settings.code;

        if (event.target == this.closeButton) return;

        if (link && image && code) {
            this.openPopup();
        } else if (link && image && !code) {
            this.openPopup();
        } else if (link && !image && code) {
            // DONE WITH LIQUID
        } else if (link && !image && !code) {
            // DONE WITH LIQUID
        } else if (!link && image && code) {
            const popup = this.openPopup();
            popup.addEventListener('click', (subEvent) => {
                this.copyDiscountCode(popup, subEvent);
            });
        } else if (!link && image && !code) {
            this.openPopup();
        } else if (!link && !image && code) {
            this.copyDiscountCode(this.parent, event);
        } else {
            // pure text info
        }
    }

    onOutsidePopupClick(event) {
        const overlay = document.querySelector('.sale-bar--overlay');
        const closeButton = document.querySelector('.sale-bar--popup-close-button');
        if (event.target === overlay || event.target === closeButton) this.closeOverlay();
    }

    countDown() {
        const nowTimestamp = moment().tz('Europe/Berlin').valueOf();
        const distance = this.endDateTimestamp - nowTimestamp;

        if (distance < 0 || nowTimestamp < this.startDateTimestamp) {
            this.backup = this;
            this.removeBar();
            return;
        } else {
            if (!document.querySelector('sale-bar')) this.parent.append(this.backup);
            this.showBar();
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, '0');
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
        const seconds = Math.floor((distance % (1000 * 60)) / 1000).toString().padStart(2, '0');
        const counterContainer = this.querySelector('.sale-bar--counter');

        counterContainer.querySelector('.days').innerHTML = days + 'D';
        counterContainer.querySelector('.hours').innerHTML = hours + 'H';
        counterContainer.querySelector('.minutes').innerHTML = minutes + 'M';
        counterContainer.querySelector('.seconds').innerHTML = seconds + 'S';
    }

    copyDiscountCode(rectElement, event) {
        const rect = rectElement.getBoundingClientRect();
        if (!rect) return;
        const x = event.clientX - rect.left - 60;
        const y = event.clientY - rect.top - 30;

        if (navigator.clipboard) {
            navigator.clipboard.writeText(this.settings.code.toUpperCase());
        }

        this.showTooltipBriefly(rectElement, x, y);
    }

    showTooltipBriefly(rectElement, x, y) {
        const tooltip = document.createElement('div');
        const code = document.createElement('span');
        tooltip.classList.add('sale-bar--tooltip');
        tooltip.innerHTML = this.settings.copied;
        tooltip.style.left = `${x}px`;
        tooltip.style.top = `${y}px`;
        code.innerHTML = this.settings.code;

        tooltip.prepend(code);
        rectElement.append(tooltip);

        setTimeout(() => {
            tooltip.style.opacity = '0';
            tooltip.addEventListener('transitionend', () => tooltip.remove());
        }, 1000);
    }

    openOverlay() {
        let overlay = document.querySelector('.sale-bar--overlay.overlay');

        if (overlay) {
            overlay.style.removeProperty('display');
            return overlay;
        } else {
            overlay = document.createElement('div');
            overlay.classList.add('sale-bar--overlay', 'overlay');
            document.body.prepend(overlay);
            return overlay;
        }
    }

    closeOverlay() {
        const overlay = document.querySelector('.sale-bar--overlay');
        if (overlay) overlay.style.display = 'none';
    }

    openPopup() {
        let popup = document.querySelector('.sale-bar--popup');

        if (popup) {
            // unhide overlay with content instead of deleting and creating it everytime
            this.openOverlay();
        } else {
            // initially create overlay and popup
            popup = document.createElement('div');
            const overlay = this.openOverlay();
            const closeButton = `<div class="sale-bar--popup-close-container"><div class="sale-bar--popup-close-button">${this.settings.close}</div></div>`;
            const spinner = '<div class="sale-bar--spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>';
            const link = this.settings.link;
            const code = this.settings.code;
            let imgTag = this.settings.imgTag;
            if (link && code) imgTag = `<a href="/discount/${code}?redirect=${link}">${imgTag}</a>`;
            if (link && !code) imgTag = `<a href="${link}">${imgTag}</a>`;
            if (!link && code) popup.setAttribute('title', this.settings.copy);
            popup.innerHTML = closeButton + spinner + imgTag;
            popup.classList.add('sale-bar--popup');
            overlay.append(popup);
        }

        return popup;
    }

    setSupportButtonMargin(margin) {
        if (!margin) return;

        const innerHTML = `#launcher { margin-bottom: ${margin}px !important; }`;

        // get or create style element
        let supportButtonStyleElement = document.getElementById('supportButtonStyle');
        if (!supportButtonStyleElement) {
            supportButtonStyleElement = document.createElement('style');
            supportButtonStyleElement.setAttribute('id', 'supportButtonStyle');
            $('body').append(supportButtonStyleElement);
        }

        // escape if there is no change
        if (supportButtonStyleElement.innerHTML == innerHTML) return;

        supportButtonStyleElement.innerHTML = innerHTML;
    }
});
